{
  "toast_saved": "Saved",
  "toast_deleted": "Deleted",
  "toast_error": "Error",
  "save": "Save",
  "saving": "Saving…",
  "node_unwired": "Not yet active — no backend event sender available",
  "node_not_implemented": "This action is not available yet",
  "dry_run": "Dry run",
  "dry_run_hint": "Test the flow safely with a sample event (no actions are actually executed)",
  "dry_run_save_first": "Save the flow first, then dry run",
  "dry_run_matched": "Dry run: trigger matches, {{count}} action(s) would execute",
  "dry_run_not_implemented": "Dry run: action “{{subtype}}” is not available yet",
  "dry_run_no_match": "Dry run: trigger does not match",
  "toast_save_error": "Save error",
  "active": "Active",
  "inactive": "Inactive",
  "inactiveLabel": "Inactive",
  "allAgents": "All Agents",
  "allChannels": "All Channels",
  "allHeartbeatTasks": "All Heartbeat Tasks",
  "canvasEmptyHint": "Drag nodes from the palette to get started",
  "canvasEmptySubHint": "Connect a trigger, add conditions and actions to build your flow",
  "caseInsensitive": "Case insensitive",
  "channelMissing": "Please select a channel",
  "conditionNo": "No",
  "conditionYes": "Yes",
  "copyUrl": "Copy URL",
  "discordChannelIdHint": "Enter the numeric Discord channel ID (right-click channel → Copy ID)",
  "flowNamePlaceholder": "My automation flow",
  "groupAction": "Actions",
  "groupCondition": "Conditions",
  "groupTrigger": "Triggers",
  "ignoreInfo": "Messages matching this condition will be silently ignored",
  "instructionPassedHint": "The trigger message will be passed to the agent as the user instruction",
  "labelAgent": "Agent",
  "labelBodyJson": "Body (JSON)",
  "labelChannel": "Channel",
  "labelChannelId": "Channel ID",
  "labelComment": "Comment",
  "labelDays": "Days",
  "labelDescription": "Description",
  "labelFieldDotNotation": "Field (dot notation)",
  "labelFrom": "From",
  "labelInstruction": "Instruction",
  "labelIssueNumber": "Issue Number",
  "labelKeyword": "Keyword",
  "labelMessage": "Message",
  "labelRecipient": "Recipient",
  "labelReplyText": "Reply Text",
  "labelRepo": "Repository",
  "labelSubject": "Subject",
  "labelTargetUrl": "Target URL",
  "labelTaskId": "Interval task ID (optional)",
  "labelText": "Text",
  "labelTitle": "Title",
  "labelTo": "To",
  "labelValueContains": "Value Contains",
  "labelWebhookUrl": "Webhook URL",
  "newFlowName": "New Flow",
  "newFlowOption": "Create new flow",
  "nodePalette": "Node Palette",
  "overnightSupported": "Overnight schedules are supported (e.g. 22:00–06:00)",
  "paletteDragHint": "Drag nodes onto the canvas",
  "placeholderFieldExample": "e.g. pull_request.title",
  "placeholderHint": "Start typing…",
  "placeholderInstructionExample": "e.g. Summarise the message and reply",
  "placeholderKeywordExample": "e.g. urgent",
  "placeholderRecipientExample": "e.g. user@example.com",
  "placeholderReplyExample": "e.g. Thanks, I'll look into it!",
  "placeholderSubjectExample": "e.g. Invoice",
  "placeholderTaskIdExample": "e.g. heartbeat-daily",
  "placeholderTriggeredBy": "Triggered by…",
  "placeholderValueExample": "e.g. expected value",
  "postToTrigger": "Post to Trigger",
  "properties": "Properties",
  "queueInfo": "Messages are processed sequentially in the order they arrive",
  "removeNode": "Remove Node",
  "replyDirectHint": "The reply will be sent directly to the source of the trigger message",
  "repoMissing": "Please enter a repository",
  "selectAgent": "Select an agent",
  "smtpHint": "SMTP settings are configured in the agent's email integration",
  "toMissing": "Please enter a recipient",
  "urlMissing": "Please enter a URL",
  "nodeMessageReceived": "Message Received",
  "nodeWebhookReceived": "Webhook Received",
  "nodeHeartbeatTask": "Heartbeat Task",
  "nodeTimeWindow": "Time Window",
  "nodeDayOfWeek": "Day of Week",
  "nodeMessageContains": "Message Contains",
  "nodePayloadFieldContains": "Payload Field Contains",
  "nodeAgentReply": "Agent Reply",
  "nodeAgentReplyGuided": "Agent Reply (Guided)",
  "nodeReplyFixed": "Fixed Reply",
  "nodeQueue": "Queue",
  "nodeIgnore": "Ignore",
  "nodeForward": "Forward",
  "nodeHttpPost": "HTTP POST",
  "nodeSendEmail": "Send Email",
  "nodeGitCreateIssue": "Create Git Issue",
  "nodeGitAddComment": "Add Git Comment",
  "nodeDiscordPost": "Discord Message",
  "badge_soon": "soon",
  "toast_unwired": "“{{subtype}}” is still a placeholder and does nothing. Remove it, then save.",
  "nodeCronFired": "Schedule (cron)",
  "nodeRegexMatch": "Regex match",
  "labelCron": "Cron expression",
  "cronUtcHint": "minute hour day month weekday — times in UTC",
  "cronMissing": "Cron missing",
  "labelRegex": "Regular expression",
  "regexHint": "Checked against the message text, case-sensitive",
  "webhookAnyHint": "Any webhook of the project",
  "webhookNeedsProject": "This trigger needs a project. Open the Butler from the project cockpit and the webhook URL will appear here.",
  "webhookSecretHint": "The call needs the X-Webhook-Secret header. The secret is in the project cockpit under Integrations."
}
